import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const fetchTopPostsItems = async ({ endpoint, page, perPage }) => {
  const { data } = await axios.get(
    endpoint({
      page,
      per_page: perPage,
    }),
  );

  return {
    posts: data?.models || data?.posts || [],
    total: data?.total_items || 0,
  };
};
